
export const getAlertCount = (alertDetails) => {
    let count = 0;
    alertDetails.forEach(item => {
        if (item.viewed === false) {
            count++
        }
    })
    return count
}